import { Modal, Alert } from "antd";

const DeleteCourseModal = ({
  visible,
  onCancel,
  onOk,
  courseName,
  isLoading
}) => (
  <Modal
    title="Delete Course"
    open={visible}
    onOk={onOk}
    onCancel={onCancel}
    okType="danger"
    okText="Delete"
    confirmLoading={isLoading}
  >
    <Alert
      message="Warning"
      description="This action cannot be undone. All course data will be permanently deleted."
      type="warning"
      showIcon
      style={{ marginBottom: 16 }}
    />
    <p>Are you sure you want to delete the course <b>{courseName}</b>?</p>
  </Modal>
);

export default DeleteCourseModal;